import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag } from 'lucide-react';
const buyers = [{
  name: 'María G.',
  city: 'CDMX'
}, {
  name: 'Ana P.',
  city: 'Bogotá'
}, {
  name: 'Laura S.',
  city: 'Buenos Aires'
}, {
  name: 'Carmen R.',
  city: 'Lima'
}, {
  name: 'Sofía T.',
  city: 'Santiago'
}, {
  name: 'Patricia M.',
  city: 'Madrid'
}, {
  name: 'Daniela V.',
  city: 'Monterrey'
}, {
  name: 'Valentina H.',
  city: 'Medellín'
}, {
  name: 'Isabella F.',
  city: 'Guadalajara'
}, {
  name: 'Gabriela L.',
  city: 'Quito'
}, {
  name: 'Andrea C.',
  city: 'Caracas'
}, {
  name: 'Mariana D.',
  city: 'Puebla'
}, {
  name: 'Lucía B.',
  city: 'Córdoba'
}, {
  name: 'Elena K.',
  city: 'Cancún'
}, {
  name: 'Rosa N.',
  city: 'Barranquilla'
}];
export function PurchasePopup() {
  const [current, setCurrent] = useState<number | null>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    let index = 0;
    const showNext = () => {
      setCurrent(index);
      setVisible(true);
      setTimeout(() => {
        setVisible(false);
      }, 3500);
      index = (index + 1) % buyers.length;
    };
    // First popup after 10 seconds
    const initialTimeout = setTimeout(() => {
      showNext();
      // Then every 10 seconds
      const interval = setInterval(showNext, 10000);
      return () => clearInterval(interval);
    }, 10000);
    return () => clearTimeout(initialTimeout);
  }, []);
  const buyer = current !== null ? buyers[current] : null;
  return <AnimatePresence data-id="element-347">
      {visible && buyer && <motion.div initial={{
      x: -300,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -300,
      opacity: 0
    }} transition={{
      type: 'spring',
      damping: 25,
      stiffness: 300
    }} className="fixed bottom-20 left-4 z-40 bg-white rounded-lg shadow-lg border border-brand-brown/20 px-4 py-3 flex items-center gap-3 max-w-[280px]" data-id="element-348">
          <div className="w-8 h-8 bg-brand-purple/10 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-349">
            <ShoppingBag size={14} className="text-brand-purple" data-id="element-350" />
          </div>
          <div className="min-w-0" data-id="element-351">
            <p className="text-xs font-semibold text-slate-800 truncate" data-id="element-352">
              {buyer.name} de {buyer.city}
            </p>
            <p className="text-[11px] text-slate-400" data-id="element-353">
              acaba de comprar CERO DECISIONES
            </p>
          </div>
          <div className="w-1.5 h-1.5 bg-brand-purple rounded-full animate-pulse flex-shrink-0" data-id="element-354" />
        </motion.div>}
    </AnimatePresence>;
}